import {Component, inject, AfterViewInit, OnDestroy} from '@angular/core';
import {
  ContentComponent,
  ExplorerService,
  TreeComponent,
  DataService,
  BreadcrumbsComponent,
  IconsComponent,
  ListComponent,
  ExplorerComponent
} from 'filemanager-explorer';
import {map, tap, Subscription} from 'rxjs';
import {AsyncPipe} from '@angular/common';
import {MaterialModule} from '@app/material.module';
import {CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import {ExplorerEntity} from '@interfaces/explorer-entity';
import { FilemanagerService } from '@app/core/services/filemanager/filemanager.service';
import { RagStatusPollingService } from '@app/core/services/filemanager/rag-status-polling.service';

@Component({
  selector: 'app-filemanager',
  imports: [ExplorerComponent, MaterialModule],
  standalone: true,
  templateUrl: './filemanager.component.html',
  styleUrl: './filemanager.component.scss',
  providers: [RagStatusPollingService],
})
export class FilemanagerComponent implements AfterViewInit, OnDestroy {

  public _explorerService = inject(ExplorerService);
  public fileManagerService: FilemanagerService = inject(FilemanagerService);
  private ragStatusPolling = inject(RagStatusPollingService);

  protected openedDir$ = this._explorerService.openedDir$.pipe(map((p) => p?.data['name']));
  protected selectionLength$ = this._explorerService.selection$.pipe(map((s) => s.length));
  protected rootLen$ = this._explorerService.root$.pipe(map((r) => r.children.length));


  // Sottoscrizione al file aperto. ExplorerService è un singleton (providedIn:
  // 'root'), quindi la teniamo tracciata e la chiudiamo in ngOnDestroy: senza
  // questo, ogni visita alla pagina lasciava una subscription viva e il doppio
  // click apriva la modale del documento tante volte quante le visite.
  private openFileSub: Subscription = this._explorerService.openFile$.subscribe((f: any) => {
    if (f && f?.isLeaf && f?.data) {
      // in this case is double clicked on a file
      // confirm('double clicked on a file '+ f['name']);
      this.fileManagerService.editFile(f.data)
      // this.selection.emit([f])
    }
  });

  constructor() {
    // this.explorerService.openTree({ id: 15, name: 'Aerosmith', path: '/Music/Rock/' });
    // Avvia l'osservazione dello stato RAG: pollerà (senza loader) solo quando
    // nella cartella corrente c'è un documento in 'pending'.
    this.ragStatusPolling.init();
    this._explorerService.openNode();
  }

  customMenuItems = [
    {
      icon: 'add',
      tooltip: 'Test Button',
      callback: () => this.customAction()
    }
  ];

  ngAfterViewInit() {
    setTimeout(() => {
      // Esegui l'operazione di apertura della cartella
      // this._explorerService.openNode();
      this._explorerService.root$.subscribe((root) => {
        //console.log('Root:', root);
      });
    }, 500);
  }

  ngOnDestroy() {
    this.openFileSub.unsubscribe();
    // Reset del file aperto sul singleton: evita che al rientro nella pagina il
    // BehaviorSubject riproponga l'ultimo file e riapra la modale da solo.
    this._explorerService.openFile(undefined);
  }

  onCustomAction(entity:ExplorerEntity) {
    //console.log("entity: ", entity);
  }

  customAction(){

  }

}
